<template>
  <div class="lm-comment" v-if="showEditButton && isVisible">
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      @click="$emit('edit-button-clicked')"
    />
    <p class="lm-comment__text">
      <strong v-if="commentPrefix" class="lm-comment__prefix">{{commentPrefix}}</strong>
      {{comment}}</p>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: true
    },
    comment: {
      type: String,
      default: ''
    },
    commentPrefix: {
      type: String,
      default: ''
    },
    showEditButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>
